export default __webpack_public_path__ + "static/media/UpperHalfSquare.5a1dc53d.svg";